import { APIURL } from "../models/api-base";
import fetchService from "../modules/APIService";

class Service extends fetchService {
  constructor() {
    super(APIURL);
  }

  getChannels = async () => {
    try {
      return await this.get("/api/notifications/channels");
    } catch (error) {
      throw error;
    }
  };

  sendToChannel = async (data) => {
    try {
      return await this.post("/api/notifications/send", data);
    } catch (error) {
      throw error;
    }
  };
}

const NotificationService = new Service();
export default NotificationService;
